import PrequalifyModalHandler from './PrequalifyModalHandler';
import QuestionStorageBuilder from '../storage/QuestionStorageBuilder';
import UrlHelper from '../../../../components/UrlHelper';
import PrequalState from '../PrequalState';

class FirstQuestionHandler {
	static handle($prequalifyModal) {
		let prequalIsShown = false;

		const questionsOwnerPageId = $prequalifyModal.data('questions-owner-page-id');
		const totalQuestions = $prequalifyModal.data('total-questions');
		const firstQuestion = $prequalifyModal.data('first-question');
		const showCloseButton = $prequalifyModal.data('show-close-button');
		const mandatoryPrequel = $prequalifyModal.data('mandatory-prequel');
		const prequelId = $prequalifyModal.data('prequel-id');

		const redirectSourcePageId = UrlHelper.getParam(window.location.href, PrequalState.PARAM_REDIRECT_SOURCE_PAGE);

		if (redirectSourcePageId) {
			UrlHelper.removeParamFromCurrentUrl(PrequalState.PARAM_REDIRECT_SOURCE_PAGE);
		}

		const questionStorage = QuestionStorageBuilder.buildForFirstQuestion({
			questionsOwnerPageId,
			totalQuestions,
			firstQuestion,
			showCloseButton: !!showCloseButton,
			mandatoryPrequel,
			prequelId,
			redirectSourcePageId
		});

		// const link = $prequalifyModal.data('page-' + questionStorage.getLinkPageId());
		const link = null;	// fix to not redirect on remembered page (#FIN-201)

		if (questionStorage.isQuestionDone() && link) {
			window.location.href = link;
			prequalIsShown = true;
		} else {
			const prequalifyModalHandler = new PrequalifyModalHandler(questionStorage);
			prequalIsShown = prequalifyModalHandler.handle();
		}

		return prequalIsShown;
	}
}

export default FirstQuestionHandler;
